<template>
  <div class="profile-wrapper">
    <h2 class="">
      My Account Summary
    </h2>
    <div class="profile-flex">
      <div class="profile-box">
        <div class="profile-photo">
          <!-- <img
            :src="userProfilePic"
            alt="profile"
            v-if="userProfilePic !== null"
          /> -->
          <img
            src="../../assets/avatar/avatar.jpg"
            alt="profile"
          >
          <label
            v-if="!isEditActive"
            for="img-upload"
          >Update Image</label>
          <label
            v-else
            for="img-upload"
          />
          <input
            id="img-upload"
            type="file"
            class="fileInput"
            name="file1"
            accept="image/*"
            multiple="false"
            :disabled="isEditActive"
            :class="{ input: isEditActive }"
            @change="addImage($event)"
          >
        </div>
        <div class="profile_info">
          <h3>hjvjhjh</h3>
          <input
            v-model="designation"
            type="text"
            class="designation"
            :disabled="isEditActive"
            :class="{ input: isEditActive }"
          >
          <input
            v-model="company"
            type="text"
            class="company"
            :disabled="isEditActive"
            :class="{ input: isEditActive }"
          >
          <!-- <span class="designation">{{ designation }}</span> -->
          <!-- <span class="company">{{ company }}</span> -->
        </div>
      </div>

      <div class="duration">
        <span class="since">Member since</span>
        <span class="date">gjhgjhgbjk</span>
      </div>
      <div class="status">
        <span class="profile-status">Status</span>
        <span class="show-status">svsvsv</span>
      </div>
    </div>

    <div class="details-wrapper">
      <div class="heading-flex">
        <span>Profile Details</span>
        <span
          v-if="isEditActive"
          class="edit_active_btn editmodeactive"
          @click="enableEditMode"
        >
          Edit profile details</span>
        <span
          v-if="!isEditActive"
          class="edit_active_btn editmodeactive"
          @click="updateUserData"
        >
          Save</span>
        <span
          v-if="!isEditActive"
          class="edit_active_btn editmodeactive"
          @click="cancelEditMode"
        >
          Cancel</span>
      </div>
      <div class="info-group">
        <span class="keys">Full name</span>
        <span class="values">bdbdbd</span>
      </div>
      <div class="info-group">
        <span class="keys">Email</span>
        <span class="values">bdgbdgb</span>
      </div>
      <div class="info-group">
        <span class="keys">Contact</span>
        <div
          v-if="!isEditActive"
          class="values"
        >
          987825545
        </div>
        <vue-tel-input v-model="contactNumber" />
      </div>
      <div class="info-group">
        <span class="keys">Profile Name</span>
        <input
          v-model="profileName"
          type="text"
          class="values"
          :class="{ input: isEditActive }"
          :disabled="isEditActive"
        >
      </div>
      <div class="info-group">
        <span class="keys">Gender</span>
        <div
          v-if="isEditActive"
          class="values"
        >
          b dgbdbdb
        </div>
        <select-gender
          v-else
          :current-gender="gender"
          @selectedInput="selectGender"
        />
      </div>
      <div class="info-group">
        <span class="keys">Full Address</span>
        <input
          v-model="fullAddress"
          type="text"
          :class="{ input: isEditActive }"
          class="values"
          :disabled="isEditActive"
        >
      </div>
      <div class="info-group">
        <span class="keys">Birthday</span>
        <input
          v-model="dob"
          type="date"
          name="date"
          class="values"
          :class="{ input: isEditActive }"
          :disabled="isEditActive"
        >
      </div>
      <hr>
      <account-actions />
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
import AccountActions from './AccountActions.vue';
import { VueTelInput } from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import SelectGender from './SelectGender.vue';
export default {
  components: { AccountActions, VueTelInput, SelectGender },
  emits: ['addProfileImage', 'updateProfile'],
  props: ['userData', 'userProfilePic'],
  data() {
    return {
      displayName: this.userData.displayName,
      emailId: this.userData.email,
      contactNumber: '4787458785',
      profileName: 'Tester',
      // contactNumber: this.userData.phoneNumber,
      // profileName: this.userData.displayName,
      gender: this.userData.gender || 'Not Specified',
      fullAddress: 'Not set',
      dob: this.userData.dob || '2017-07-04',
      designation: 'Not set',
      imgUrl: this.userData.imgUrl || 'Not set',
      role: this.userData.role,
      disabled: this.userData.disabled ? 'Disable' : 'Active',
      company: this.userData.companyName || 'Company : Not set',
      isEditActive: true,
    };
  },
  methods: {
    selectGender(val) {
      this.gender = val;
    },
    isNumber(evt) {
      this.contactNumber = evt.target.value?.replace(/[^0-9,+]/g, '');
    },
    addImage(e) {
      this.$emit('addProfileImage', e);
    },
    enableEditMode() {
      this.isEditActive = false;
    },

    cancelEditMode() {
      this.isEditActive = true;
    },
    updateUserData() {
      let payload = {
        phoneNumber: this.contactNumber,
        profileName: this.profileName,
        gender: this.gender,
        fullAddress: this.fullAddress,
        dob: this.dob,
        companyName: this.company,
        jobPosition: this.designation,
      };
      this.$emit('updateProfile', payload);
      this.isEditActive = true;
    },
  },
};
</script>

<style scoped>
.input {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: hidden;
  background-color: #eee;
  background: white;
}

.edit_active_btn {
  padding-left: 10px;
}
.profile-wrapper {
  width: 100%;
  padding-right: 1rem;
  display: flex;
  flex-direction: column;
}
.profile-wrapper h2 {
  font-family: Inter;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  padding-bottom: 1rem;
  margin-top: 3rem;
}
.profile-box {
  display: flex;
}
.profile-flex {
  display: flex;
  justify-content: space-between;
}
.profile_info {
  display: flex;
  flex-direction: column;
}
.profile_info > h3 {
  font-family: Inter;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #0f172a;
  padding-bottom: 0.5rem;
}
.designation,
.company,
.since,
.profile-status {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #64748b;
  padding-bottom: 4px;
  margin-bottom: 4px;
}
.date {
  font-family: Inter;
  font-size: 14px;
  color: #0f172a;
}
.duration,
.status {
  display: flex;
  flex-direction: column;
}
.profile-photo {
  display: flex;
  flex-direction: column;
}
.profile-photo > img {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  margin-right: 1.5rem;
  margin-bottom: 4px;
}
.profile-photo > label {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #30c56f;
  padding-left: 6px;
  cursor: pointer;
  padding-bottom: 56px;
}
input[type="file"] {
  opacity: 0; /* make transparent */
  z-index: -1; /* move under anything else */
  position: absolute; /* don't let it take up space */
}

.heading-flex {
  display: flex;
  align-items: center;
  padding-bottom: 1.5rem;
}
.heading-flex > h2 {
  padding-right: 12px;
  font-family: Inter;
  font-weight: 600;
  font-size: 19px;
  color: #0f172a;
}
.editmodeactive {
  font-family: Inter;
  font-weight: 600;
  font-size: 12px;
  color: #30c56f;
  cursor: pointer;
}
.info-group {
  display: flex;
  align-items: center;
  padding-bottom: 18px;
}
.info-group > .keys {
  width: 160px;
  font-family: Inter;
  font-size: 14px;
  color: #64748b;
  padding-right: 64px;
}
.values {
  font-family: Inter;
  font-weight: normal;
  font-size: 16px;
  color: #0f172a;
}
hr {
  border: 1px solid #e2e8f0;
  margin-bottom: 24px;
}
</style>
